var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { InputText } from "primereact/inputtext";
import * as React from 'react';
import { withRouter } from "react-router-dom";
import Grid from '../../UI/Grid/Grid';
var CategoryProductsList = /** @class */ (function (_super) {
    __extends(CategoryProductsList, _super);
    function CategoryProductsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Id', key: 'id', filter: false, sort: false },
            { name: 'Име', key: 'name', filter: false, sort: false },
            { name: "Позиция", key: 'positionCat', filter: false, sort: false }
        ];
        _this.onPage = function (event) {
            _this.props.getAllProducts(event.page + 1);
        };
        return _this;
    }
    CategoryProductsList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta, search = _a.search;
        var header = (React.createElement("div", { style: { 'textAlign': 'left' } },
            React.createElement("i", { className: "pi pi-search", style: { margin: '4px 4px 0 0' } }),
            React.createElement(InputText, { type: "search", onInput: search, placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435 \u043F\u043E \u0431\u0430\u0440\u043A\u043E\u0434" })));
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: !!meta, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, header: header }));
    };
    return CategoryProductsList;
}(React.Component));
// @ts-ignore
export default withRouter(CategoryProductsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/categoryProducts/ProductsList/CategoryProductsList.tsx
// module id = 335
// module chunks = 0